import {
  Wrench, Users, Palette, HeartHandshake, Compass,
  PhoneCall, ClipboardCheck, Settings, LineChart,
} from "lucide-react";

export const IMAGES = {
  logoLight: "/proxilia-logo-light.png",
  logoDark: "/proxilia-logo-dark.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/9ed224f7-92ed-4af2-bcf5-cf552c4d57f5/images/bedcaedb9c35294282913bffbedf489c0f63f0c0b2bbc09471a0d34d14577ee7.png",
  about: "https://static.prod-images.emergentagent.com/jobs/9ed224f7-92ed-4af2-bcf5-cf552c4d57f5/images/1bc54cff9d2c0ca53c5a51df2afe537e43656a7a924dc380cbe57f67aa78d837.png",
  leisure: "https://static.prod-images.emergentagent.com/jobs/9ed224f7-92ed-4af2-bcf5-cf552c4d57f5/images/50e006f1c77eb1556b98fc6f4e357f808c52c3c157e76d3086bbbbc5250820c2.png",
  t1: "https://images.unsplash.com/photo-1749189516333-168cfd97de0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  t2: "https://images.unsplash.com/photo-1547212371-eb5e6a4b590c?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  t3: "https://images.unsplash.com/photo-1614526261628-295d39158f96?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
};

export const STATS = [
  { value: "98%", label: "Satisfaction clients" },
  { value: "7j/7", label: "Disponibilité" },
  { value: "100%", label: "Accompagnement personnalisé" },
];

export const SERVICES = [
  {
    icon: Wrench,
    title: "Organisation & suivi",
    desc: "Une gestion sereine de votre quotidien et de votre logement.",
    items: ["Recherche d’artisans", "Suivi de travaux", "Gestion de la maison", "Aide administrative (CAF, impôts, etc.)", "Présence pour discuter", "Aide en cas d’imprévus", "Coordination des interventions"],
    large: true,
  },
  {
    icon: Users,
    title: "Loisirs & lien social",
    desc: "Des sorties et des promenades pour entretenir le lien.",
    items: ["Sorties accompagnées", "Promenades", "Marchés", "Sorties en ville", "Balades nature"],
    large: true,
  },
  {
    icon: Palette,
    title: "Activités culturelles",
    desc: "Cinéma, musées, spectacles et expositions.",
    items: ["Cinéma", "Musées", "Spectacles", "Expositions", "Événements culturels"],
  },
  {
    icon: HeartHandshake,
    title: "Convivialité & partage",
    desc: "Des moments chaleureux d’échange et de mémoire.",
    items: ["Visites de convivialité", "Jeux de société", "Moments d’échange", "Ateliers mémoire"],
  },
  {
    icon: Compass,
    title: "Découvertes & sorties organisées",
    desc: "Explorez votre région en toute confiance.",
    items: ["Sorties à la journée", "Découverte de la région", "Visites locales", "Événements régionaux"],
  },
];

export const PROCESS = [
  { n: "01", icon: PhoneCall, title: "Premier échange gratuit", desc: "Un premier contact pour faire connaissance et comprendre vos attentes, sans engagement." },
  { n: "02", icon: ClipboardCheck, title: "Évaluation des besoins", desc: "Nous évaluons ensemble vos besoins afin de construire un accompagnement sur mesure." },
  { n: "03", icon: Settings, title: "Mise en place de l’accompagnement", desc: "Nous organisons les interventions et présentons votre intervenant dédié." },
  { n: "04", icon: LineChart, title: "Suivi personnalisé continu", desc: "Un suivi régulier et des ajustements pour une sérénité durable." },
];

export const PLANS = [
  {
    name: "Pack Tranquillité",
    price: "120",
    badge: null,
    features: ["4h d’accompagnement par mois", "Assistance téléphonique", "Aide administrative simple", "Suivi personnalisé"],
  },
  {
    name: "Pack Sérénité",
    price: "200",
    badge: "Le plus populaire",
    featured: true,
    features: ["8h d’accompagnement par mois", "Courses et rendez-vous", "Aide administrative", "1 sortie loisirs incluse", "Suivi personnalisé"],
  },
  {
    name: "Pack Premium Famille",
    price: "299",
    badge: "Premium",
    features: ["12h d’accompagnement par mois", "Suivi régulier", "Compte-rendu à la famille", "2 sorties loisirs incluses", "Priorité sur les interventions"],
  },
];

export const TESTIMONIALS = [
  { quote: "Une tranquillité d'esprit incroyable pour notre famille.", name: "Sophie L.", role: "Fille d’un client", img: IMAGES.t1 },
  { quote: "Une équipe bienveillante et toujours disponible.", name: "Marguerite D.", role: "Cliente Proxilia", img: IMAGES.t2 },
  { quote: "Ma mère a retrouvé une vraie vie sociale.", name: "Antoine R.", role: "Fils d’une cliente", img: IMAGES.t3 },
];

export const FAQ = [
  { q: "Comment fonctionne l'accompagnement ?", a: "Après un premier échange gratuit, nous évaluons vos besoins et mettons en place un intervenant dédié. Chaque accompagnement est entièrement personnalisé et ajusté au fil du temps." },
  { q: "Intervenez-vous à domicile ?", a: "Oui, nos intervenants se déplacent à votre domicile et vous accompagnent également lors de vos sorties, rendez-vous et activités à l’extérieur." },
  { q: "Les prestations sont-elles personnalisées ?", a: "Absolument. Chaque formule est adaptée à votre rythme, vos envies et vos besoins. Rien n’est standardisé : tout est pensé pour vous." },
  { q: "Comment démarrer ?", a: "Il vous suffit de demander à être rappelé via notre formulaire. Nous vous recontactons rapidement pour planifier votre premier échange gratuit." },
];

export const NAV_LINKS = [
  { label: "Accueil", href: "#hero" },
  { label: "Services", href: "#services" },
  { label: "Nos formules", href: "#tarifs" },
  { label: "Contact", href: "#contact" },
];
